import { Endpoint } from '../../services/endpoint';

export class CommissionEndpoint extends Endpoint {
  protected resourceType = 'MerchantProfile';
}
